<template>
  <v-data-table
        :headers="headers"
        :items="morbilidades"
        :sort-desc="[false, true]"
        :items-per-page="10"
        multi-sort
        class="elevation-0 border"
      ></v-data-table>
</template>

<script>
export default {
  name: "TablaMorbilidades",

  data: () => ({
    headers: [
      { text: "", value: "num" },
      { text: "MORBILIDAD", value: "DESCRIPCION_MORBILIDAD" },
      { text: "MASCULINO", value: "MASCULINO" },
      { text: "FEMENINO", value: "FEMENINO" },
      { text: "TOTAL", value: "TOTAL" },
    ],
  }),
  props: ["morbilidades"],
};
</script>